interface Props {
  icon: React.FC;
  title: string;
  info?: string;
  iconColor?: string;
  body?: React.ReactNode,
  bgColor?: string,
  glass?: boolean;
  className?: string,
}

const IconInfoCard: React.FC<Props> = ({
  icon, iconColor, info, title, body, bgColor, glass = true, className,
}) => (
  <div className={`flex flex-col justify-center items-center h-30 ${glass ? 'glass-surface' : ''} ${bgColor} ${className}`}>
    <div className="h-8 w-8 mb-3">{icon(({ className: `${iconColor} h-8 w-8` }))}</div>
    <h1 className="text-lg font-medium text-center mb-3.5">{title}</h1>
    {info && <p className="text-center text-text-tertiary">{info}</p>}
    {body}
  </div>
);

export default IconInfoCard;
